"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
exports.__esModule = true;
var parseLang_1 = require("./parseLang");
exports.hasOperator = function (operator) { return function (filter) {
    return filter.operator === operator;
}; };
function buildArrayString(vals) {
    return "[" + vals.map(function (v) { return "(" + v + ")"; }).join(",") + "]";
}
exports.buildArrayString = buildArrayString;
function buildFilterString(fil) {
    if (typeof fil.value === "string") {
        return fil.columnKey + " " + fil.operator + " (" + fil.value + ")";
    }
    else {
        return fil.columnKey + " " + fil.operator + " (" + buildArrayString(fil.value) + ")";
    }
}
exports.buildFilterString = buildFilterString;
function deserialiseFilters(filterString) {
    var filters = parseLang_1.parseExpression(filterString).orDefault([]);
    var columns = new Set(filters.map(function (f) { return f.columnKey; }));
    return __spread(columns).map(function (columnKey) { return ({
        columnKey: columnKey,
        filters: filters.filter(function (f) { return f.columnKey === columnKey; })
    }); });
}
exports.deserialiseFilters = deserialiseFilters;
function serializeFilters(filters) {
    return filters
        .map(function (f) { return f.filters; })
        .flatMap(function (f) { return f.map(buildFilterString); })
        .join(" | ");
}
exports.serializeFilters = serializeFilters;
